import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"

export default function TrackingRender({ renderPkg }:{ renderPkg?:any }){

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "tracking")?.settings || null

  const firstPStyle = useRenderStyling("block mb-0 leading-tight", "styleObj")
  const outerStyling = useRenderStyling("mm-section w-full flex flex-col pl-0 mb-4", "styleObj")
  const innerStyling = useRenderStyling("w-full mt-4 pl-4 pr-6", "styleObj")
  const wrapperStyling = useRenderStyling("mt-3 mb-1", "styleObj")
  const contentStyling = useRenderStyling("flex flex-col leading-tight", "styleObj")

  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata} 

  let notes:any[] = [] 

  return <></>
  return (
    <div id="mm-pkg-tracking" {...outerStyling}>

      <SectionHeaderRender title="Package Tracking" />

      <div {...innerStyling}>
        <div {...wrapperStyling}>
          <div {...contentStyling}>
            <p>Tracking data goes here</p>
          </div>
        </div>
      </div>
    </div>
  )
}